import { BowAwardTile } from '@client/components/bow-award-tile/BowAwardTile';
import { HofAwardTile } from '@client/components/hof-award-tile/HofAwardTile';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { vendorAwardsAtom } from '../../../../jotai/storefront/awards-summary';
import Styles from './AwardItems.scss';
import { isQualifyingBowAward } from './constants';

export const AwardItems = () => {
	const awards = useAtomValue(vendorAwardsAtom);

	const hasQualifyingBowAwards = useMemo(
		() => awards.some(isQualifyingBowAward),
		[awards],
	);

	const hasHofAward = useMemo(
		() => awards.some((award) => award.type === 'HOF'),
		[awards],
	);

	if (!hasQualifyingBowAwards && !hasHofAward) {
		return null;
	}

	return (
		<div className={Styles.enhancedAwardsContainer}>
			{hasQualifyingBowAwards && <BowAwardTile />}
			{hasHofAward && <HofAwardTile />}
		</div>
	);
};
